







import { Component, Vue } from 'vue-property-decorator';
import Search from '@/components/search/Search.vue';
import searchStore from '@/store/modules/search/searchStore';

@Component({
  beforeRouteEnter: async (to, from, next) => {
    if (!searchStore.state.categories.loaded) {
      await searchStore.dispatch.fetchCategories();
    }
    next();
  },
  components: {
    Search,
  },
})
export default class SearchHeader extends Vue {}
